import { render, staticRenderFns } from "./AcceptTwoStepVerification.vue?vue&type=template&id=e00271b4&scoped=true"
import script from "./AcceptTwoStepVerification.vue?vue&type=script&lang=js"
export * from "./AcceptTwoStepVerification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e00271b4",
  null
  
)

export default component.exports